<div class="status-chips" [ngClass]="getClass(status)">
  <ng-content></ng-content>
</div>